<template>
    <div>
        <b-container fluid>
            <b-form @submit="onSubmit">

                <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
                <b-form-group label="guid">
                    <b-form-input type="text" id="dataItem-guid-input" class="form-input" v-model="dataItem.guid"
                        @blur="$v.dataItem.guid.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.guid.required">guid is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="parentId">
                    <b-form-input type="text" id="dataItem-parentId-input" class="form-input"
                        v-model="dataItem.parentId" @blur="$v.dataItem.parentId.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.parentId.required">parentId is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="businessChannelId">
                    <b-form-input type="text" id="dataItem-businessChannelId-input" class="form-input"
                        v-model="dataItem.businessChannelId" @blur="$v.dataItem.businessChannelId.$touch()">
                    </b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.businessChannelId.required">businessChannelId is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="number">
                    <b-form-input type="text" id="dataItem-number-input" class="form-input" v-model="dataItem.number"
                        @blur="$v.dataItem.number.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.number.required">number is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="name">
                    <b-form-input type="text" id="dataItem-name-input" class="form-input" v-model="dataItem.name"
                        @blur="$v.dataItem.name.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.name.required">name is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="shortName">
                    <b-form-input type="text" id="dataItem-shortName-input" class="form-input"
                        v-model="dataItem.shortName" @blur="$v.dataItem.shortName.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.shortName.required">shortName is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="referenceCode1">
                    <b-form-input type="text" id="dataItem-referenceCode1-input" class="form-input"
                        v-model="dataItem.referenceCode1" @blur="$v.dataItem.referenceCode1.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.referenceCode1.required">referenceCode1 is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="referenceCode2">
                    <b-form-input type="text" id="dataItem-referenceCode2-input" class="form-input"
                        v-model="dataItem.referenceCode2" @blur="$v.dataItem.referenceCode2.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.referenceCode2.required">referenceCode2 is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="referenceCode3">
                    <b-form-input type="text" id="dataItem-referenceCode3-input" class="form-input"
                        v-model="dataItem.referenceCode3" @blur="$v.dataItem.referenceCode3.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.referenceCode3.required">referenceCode3 is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="referenceCode4">
                    <b-form-input type="text" id="dataItem-referenceCode4-input" class="form-input"
                        v-model="dataItem.referenceCode4" @blur="$v.dataItem.referenceCode4.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.referenceCode4.required">referenceCode4 is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="referenceCode5">
                    <b-form-input type="text" id="dataItem-referenceCode5-input" class="form-input"
                        v-model="dataItem.referenceCode5" @blur="$v.dataItem.referenceCode5.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.referenceCode5.required">referenceCode5 is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="numberingPrefix">
                    <b-form-input type="text" id="dataItem-numberingPrefix-input" class="form-input"
                        v-model="dataItem.numberingPrefix" @blur="$v.dataItem.numberingPrefix.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.numberingPrefix.required">numberingPrefix is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="sSOType">
                    <b-form-input type="text" id="dataItem-sSOType-input" class="form-input" v-model="dataItem.sSOType"
                        @blur="$v.dataItem.sSOType.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.sSOType.required">sSOType is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="website">
                    <b-form-input type="text" id="dataItem-website-input" class="form-input" v-model="dataItem.website"
                        @blur="$v.dataItem.website.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.website.required">website is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="linkedin">
                    <b-form-input type="text" id="dataItem-linkedin-input" class="form-input"
                        v-model="dataItem.linkedin" @blur="$v.dataItem.linkedin.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.linkedin.required">linkedin is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="twitter">
                    <b-form-input type="text" id="dataItem-twitter-input" class="form-input" v-model="dataItem.twitter"
                        @blur="$v.dataItem.twitter.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.twitter.required">twitter is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="facebook">
                    <b-form-input type="text" id="dataItem-facebook-input" class="form-input"
                        v-model="dataItem.facebook" @blur="$v.dataItem.facebook.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.facebook.required">facebook is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="instagram">
                    <b-form-input type="text" id="dataItem-instagram-input" class="form-input"
                        v-model="dataItem.instagram" @blur="$v.dataItem.instagram.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.instagram.required">instagram is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="taxEIN">
                    <b-form-input type="text" id="dataItem-taxEIN-input" class="form-input" v-model="dataItem.taxEIN"
                        @blur="$v.dataItem.taxEIN.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.taxEIN.required">taxEIN is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="businessEntityType">
                    <b-form-input type="text" id="dataItem-businessEntityType-input" class="form-input"
                        v-model="dataItem.businessEntityType" @blur="$v.dataItem.businessEntityType.$touch()">
                    </b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.businessEntityType.required">businessEntityType is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="stateOfIncorporation">
                    <b-form-input type="text" id="dataItem-stateOfIncorporation-input" class="form-input"
                        v-model="dataItem.stateOfIncorporation" @blur="$v.dataItem.stateOfIncorporation.$touch()">
                    </b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.stateOfIncorporation.required">stateOfIncorporation is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="isDemo">
                    <b-form-input type="text" id="dataItem-isDemo-input" class="form-input" v-model="dataItem.isDemo"
                        @blur="$v.dataItem.isDemo.$touch()"></b-form-input>
                    <div class="invalid-feedback">
                        <div v-if="!$v.dataItem.isDemo.required">isDemo is required</div>
                    </div>
                </b-form-group>
                <b-form-group label="active">
                    <b-form-checkbox id="dataItem-active-input" class="form-input" v-model="dataItem.active">active
                    </b-form-checkbox>
                </b-form-group>


                <b-row>
                    <b-col md="6">
                        <label>Created</label>
                    </b-col>
                    <b-col md="6">
                        <label>Modified</label>
                    </b-col>
                </b-row>

                <b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
                <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
            </b-form>
        </b-container>

    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import service from '../../service';
    import { dataItemDto, dataItem } from '../../dto';

    export default {
        name: 'Addcompany',
        components: {

        },
        data: () => ({
            dataItem: dataItem,

        }),
        methods: {
            async onSubmit(e) {
                e.preventDefault();

                this.$v.dataItem.$touch();
                if (this.$v.dataItem.$invalid) {
                    return;
                }

                let payload = new dataItemDto(this.dataItem);
                payload.id = 0; //New records will start with an id of zero
                payload.active = true; //New records will always be true

                try {
                    const id = await service.create(payload);
                    this.redirectToListing();
                } catch { }
            },
            cancel() {
                this.redirectToListing();
            },
            redirectToListing() {
                this.$router.push({ name: 'companies' });
            }
        },
        validations: {
            dataItem: {

                id: {
                },
                guid: {
                },
                parentId: {
                },
                businessChannelId: {
                },
                number: {
                },
                name: {
                },
                shortName: {
                },
                referenceCode1: {
                },
                referenceCode2: {
                },
                referenceCode3: {
                },
                referenceCode4: {
                },
                referenceCode5: {
                },
                numberingPrefix: {
                },
                sSOType: {
                },
                website: {
                },
                linkedin: {
                },
                twitter: {
                },
                facebook: {
                },
                instagram: {
                },
                taxEIN: {
                },
                businessEntityType: {
                },
                stateOfIncorporation: {
                },
                isDemo: {
                },
                createdByUserId: {
                },
                modifiedByUserId: {
                },
                dateCreated: {
                },
                dateModified: {
                },
                active: {
                },
            }
        }
    };
</script>